<div *ngIf="model" class="np-form-control d-flex flex-column w-100 h-100">
  <div class="header d-flex flex-row px-3 pt-1 w-100 align-items-center flex-shrink-0">
    <div class="p-2">
      <span *ngIf="!categoryMainImage" class="glyphicon glyphicon-picture"></span>
      <img *ngIf="categoryMainImage" [src]="categoryMainImage"/>
    </div>

    <div class="flex-fill">
      <h5 class="mb-0 text-truncate">{{ model.groupName }}</h5>
    </div>

    <div  class="p-2 flex-shrink-0">
      <dx-bar-gauge
          id="gauge"
          [values]="[0, 0, 0]"
          [startValue]="0"
          [endValue]="100"
          [palette]="['#E59D1A', '#10907E', '#1E4B98']"
      >
        <dxo-label [visible]="false"></dxo-label>
      </dx-bar-gauge>
    </div>
  </div>

  <dx-toolbar class="np-toolbar-icon-top" style="margin-left: 80px;">
    <dxi-item
        *ngIf="renderMassDataChangeButton()"
        location="before"
        locateInMenu="auto"
        template="massDataChangeButton"
    ></dxi-item>

    <div *dxTemplate="let toolbarItem of 'massDataChangeButton'">
      <dx-button
          class="np-toolbar-icon-button"
          stylingMode="text"
          type="default"
          [disabled]="readOnly('massDataChange')"
          (onClick)="openMassDataChange()"
      >
        <div class="np-toolbar-icon-button_content">
          <img class="np-toolbar-icon-button_icon" src="images/massendaten.svg" alt=""/>
          <span class="np-toolbar-icon-button_text">{{ 'Massendatenänderung' | translate }}</span>
        </div>
      </dx-button>
    </div>
  </dx-toolbar>

  <div class="category-details-container flex-fill d-flex flex-column min-h-0">
    <dx-validation-group id="categoryValidationGroup" class="flex-fill d-flex flex-column min-h-0">
      <div class="category-tabpanel-wrapper flex-fill min-h-0">
        <dx-tab-panel
            class="detailTabs np-vertical-tabs h-100"
            [dataSource]="pages"
            [tabsPosition]="'left'"
            [(selectedIndex)]="modelService.loginService.selectedCategoryTabIndex"
            [swipeEnabled]="false"
            [showNavButtons]="true"
            [scrollByContent]="true"
            [animationEnabled]="false"
        >
          <div *dxTemplate="let company of 'categoryTemplate'">
            <div class="dx-fieldset mainInfos np-category-input-scope" *ngIf="model">
              <div class="row g-3">
                <div class="col-12 col-lg-6">
                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Kategorie' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <label class="placeLabel {{ model.groupName?.length > 0 ? 'placeLabelSmall' : '' }}">GROUP NAME</label>
                      <dx-text-box
                          [readOnly]="readOnly('categoryGroupName') || this.catalogService.catalog.isDemoCatalog"
                          [(value)]="model.groupName"
                          [showClearButton]="true"
                          valueChangeEvent="focusout"
                          (onValueChanged)="categoryChanged($event)"
                          [hint]="
                          this.catalogService.catalog.isDemoCatalog
                            ? 'Diese Funktion steht in der Zielstruktur nicht zur Verfügung'
                            : null
                        "
                      >
                        <dx-validator validationGroup="categoryValidationGroup">
                          <dxi-validation-rule
                              type="required"
                              message="{{ 'Bitte geben Sie einen Kategorienamen an' | translate }}!"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Beschreibung' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <label class="placeLabel {{ model.groupDescription?.length > 0 ? 'placeLabelSmall' : '' }}">
                        GROUP DESCRIPTION
                      </label>
                      <dx-text-area
                          [readOnly]="readOnly('categoryGroupDescription')"
                          [(value)]="model.groupDescription"
                          [height]="120"
                          valueChangeEvent="focusout"
                          (onValueChanged)="categoryChanged($event)"
                      ></dx-text-area>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Sortiernummer' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <label class="placeLabel {{ model.groupOrder != null ? 'placeLabelSmall' : '' }}">GROUP ORDER</label>
                      <dx-number-box
                          [readOnly]="readOnly('categoryGroupOrder')"
                          [(value)]="model.groupOrder"
                          [min]="0"
                          placeholder=""
                          [showSpinButtons]="true"
                          [showClearButton]="false"
                          valueChangeEvent="focusout"
                          (onValueChanged)="categoryChanged($event)"
                      ></dx-number-box>
                    </div>
                  </div>

                  <div class="dx-field">
                    <div class="dx-field-label dx-field-label200">{{ 'Group Id' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <label class="placeLabel {{ model.groupId != null ? 'placeLabelSmall' : '' }}">GROUP ID</label>
                      <dx-text-box
                          [readOnly]="readOnly('categoryGroupId')"
                          [(value)]="model.groupId"
                          [showClearButton]="false"
                          valueChangeEvent="focusout"
                          (onValueChanged)="categoryChanged($event)"
                      ></dx-text-box>
                    </div>
                  </div>

                  <div class="dx-field" *ngIf="modelService.loginService.hasAddonPRINT">
                    <div class="dx-field-label dx-field-label200">{{ 'Gleichbleibende Id' | translate }}</div>
                    <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                      <label class="placeLabel {{ model.stableId != null ? 'placeLabelSmall' : '' }}">STABLE ID</label>
                      <dx-text-box [readOnly]="true" [(value)]="model.stableId" [showClearButton]="false"></dx-text-box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *dxTemplate="let company of 'medienTemplate'">
            <mimes
                [(model)]="model.mimes"
                [(showToolTips)]="showToolTips"
                [(showProToolTips)]="showProToolTips"
                [(showPlaceHolders)]="showPlaceHolders"
                [(catalogId)]="modelService.catalogService.catalog.id"
                [(customerId)]="modelService.loginService.currentUser.customerId"
                (reloadNedded)="reload()"
                (onValueChanged)="categoryUpdate($event)"
                [(modelService)]="modelService"
            ></mimes>
          </div>

          <div *dxTemplate="let company of 'udxTemplate'">
            <udx
                [(model)]="model.udxs"
                [(showToolTips)]="showToolTips"
                [(showProToolTips)]="showProToolTips"
                [(showPlaceHolders)]="showPlaceHolders"
                (onValueChanged)="categoryUpdate($event)"
            ></udx>
          </div>

          <div *dxTemplate="let company of 'templateTemplate'">
            <categoryTemplates></categoryTemplates>
          </div>

          <div *dxTemplate="let company of 'seoTemplate'">
            <seoComponent></seoComponent>
          </div>

          <div *dxTemplate="let company of 'osgTemplate'">
            <categoryOsg></categoryOsg>
          </div>

          <div *dxTemplate="let company of 'shopware6Template'">
            <categoryShopware6></categoryShopware6>
          </div>
        </dx-tab-panel>
      </div>
    </dx-validation-group>
  </div>
</div>
